var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "device-setting-preview-component",
      class: { inRoom: !_vm.isDevicetest },
      attrs: { "data-grm-comp": "DeviceSettingPreview" },
    },
    [
      _c("div", { staticClass: "device-setting-preview" }, [
        _c("div", { staticClass: "device-set-preview" }, [
          _c("div", { staticClass: "device-set-preview-header" }, [
            _c(
              "div",
              { staticClass: "device-set-preview-title-wrapper" },
              [
                _vm.isDevicetest
                  ? _c("a", {
                      staticClass: "back-btn mobile",
                      attrs: { href: "service/room" },
                    })
                  : _vm._e(),
                _vm.isDevicetest
                  ? _c("h1", { staticClass: "device-set-preview-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("deviceSetting.preview.device.test"))
                      ),
                    ])
                  : _vm._e(),
                !_vm.isDevicetest
                  ? _c("p", { staticClass: "device-set-preview-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("deviceSetting.preview.device.setting"))
                      ),
                    ])
                  : _vm._e(),
                !_vm.isDevicetest
                  ? _c("GrmCloseBtn", { on: { click: _vm.onClose } })
                  : _vm._e(),
                _vm.isDevicetest
                  ? _c(
                      "button",
                      {
                        staticClass: "device-set-info-show-btn mobile",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("onToggleInfo")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.info")))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "device-set-preview-body" }, [
            !_vm.isIOS || (_vm.isIOS && _vm.isDevicetest)
              ? _c(
                  "div",
                  {
                    staticClass:
                      "device-set-preview-video-container rounded-lg overflow-hidden",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "device-set-preview-video-wrapper rounded-lg relative overflow-hidden",
                        class: [
                          { error: _vm.selectedDevice.video.state === "error" },
                        ],
                      },
                      [
                        _c("video", {
                          ref: "preview_video",
                          staticClass:
                            "device-set-preview-video rounded-lg bg-black previewVideo",
                          class: {
                            mirror: _vm.selectedDevice.video.usePreviewMirror,
                          },
                          attrs: { autoplay: "", muted: "", playsinline: "" },
                          domProps: { muted: true },
                        }),
                        _c(
                          "transition",
                          { attrs: { name: "fade" } },
                          [
                            _vm.selectedDevice.video.state === "loading"
                              ? _c("GrmLoadingCircle", {
                                  staticClass:
                                    "rounded-lg bg-black bg-opacity-50 absolute inset-0",
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "device-set-preview-status" }, [
                      _c(
                        "div",
                        { staticClass: "device-set-preview-status-header" },
                        [
                          _vm.isDevicetest && _vm.isShowDeviceInfo
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-status-warning-wrapper",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "device-set-preview-status-warning",
                                    },
                                    [_vm._v(_vm._s(_vm.defaultDeviceInfo))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "device-set-preview-status-footer" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "device-set-preview-status-controls",
                            },
                            [
                              _c("button", {
                                staticClass:
                                  "device-set-preview-status-control mic micStatus",
                                class: {
                                  off:
                                    _vm.selectedDevice.audio.state === "error",
                                },
                              }),
                              _c("button", {
                                staticClass:
                                  "device-set-preview-status-control camera cameraStatus",
                                class: {
                                  off:
                                    _vm.selectedDevice.video.state === "error",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass:
                  "device-set-preview-options-container optionsContainer",
              },
              [
                _c(
                  "div",
                  { staticClass: "device-set-preview-options-header" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "device-set-preview-options-tabs",
                        class: _vm.selectedTab,
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "device-set-preview-options-tab-btn video",
                            on: {
                              click: function ($event) {
                                _vm.selectedTab = "video"
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.video")))]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "device-set-preview-options-tab-btn audio",
                            on: {
                              click: function ($event) {
                                _vm.selectedTab = "audio"
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.audio")))]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "device-set-preview-options-body" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedTab === "video",
                          expression: "selectedTab === 'video'",
                        },
                      ],
                      staticClass: "device-set-preview-option-contents",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "device-set-preview-option-section" },
                        [
                          _c(
                            "div",
                            { staticClass: "device-set-preview-option-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-title-wrapper",
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "device-set-preview-option-title",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.device.camera"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "device-set-preview-option-body" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-select-wrapper",
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.selectedDevice.video.deviceId,
                                          expression:
                                            "selectedDevice.video.deviceId",
                                        },
                                      ],
                                      staticClass: "form-select",
                                      on: {
                                        input: function ($event) {
                                          return _vm.onChangeDevice(
                                            "video",
                                            $event.target.value
                                          )
                                        },
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.selectedDevice.video,
                                            "deviceId",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.devices.videoinput,
                                      function (device) {
                                        return _c(
                                          "option",
                                          {
                                            key: device.deviceId,
                                            domProps: {
                                              value: device.deviceId,
                                            },
                                          },
                                          [_vm._v(_vm._s(device.label))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-video-mirror-container",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "toggle-btn-container" },
                                    [
                                      _c("input", {
                                        staticClass: "toggle-btn",
                                        attrs: {
                                          type: "checkbox",
                                          name: "video-mirror",
                                          id: "video-mirror",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.selectedDevice.video
                                              .usePreviewMirror,
                                        },
                                        on: { input: _vm.togglePreviewMirror },
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "toggle-label",
                                          attrs: { for: "video-mirror" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "toggle-label-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "deviceSetting.preview.videoReverse"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("div", {
                                            staticClass: "toggle-status",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "device-set-preview-option-section" },
                        [
                          _c(
                            "div",
                            { staticClass: "device-set-preview-option-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-title-wrapper",
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "device-set-preview-option-title",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "deviceSetting.preview.virtualBackground.title"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _vm._m(0),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "device-set-preview-option-description",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "deviceSetting.preview.quality"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "device-set-preview-option-body" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-virtual-background-container virtualBackgroundContainer",
                                },
                                [
                                  _c("button", {
                                    staticClass:
                                      "device-set-preview-option-virtual-background-btn none",
                                    class: {
                                      selected:
                                        _vm.selectedDevice.video
                                          .virtualBackgroundType === "none",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeVirtualBackground(
                                          "none"
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "device-set-preview-option-virtual-background-btn blur",
                                      class: {
                                        selected:
                                          _vm.selectedDevice.video
                                            .virtualBackgroundType === "blur",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChangeVirtualBackground(
                                            "blur"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.isShowCoachmark
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "coach-mark-preview-virtual-background blur mobile",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "coach-mark-guide blur mobile",
                                                },
                                                [
                                                  _vm._m(1),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "coach-mark-guide-text-container",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "coach-mark-guide-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "deviceSetting.preview.virtualBackground.select"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c("button", {
                                    staticClass:
                                      "device-set-preview-option-virtual-background-btn inside_01",
                                    class: {
                                      selected:
                                        _vm.selectedDevice.video
                                          .virtualBackgroundType ===
                                        "inside_01",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeVirtualBackground(
                                          "inside_01"
                                        )
                                      },
                                    },
                                  }),
                                  _c("button", {
                                    staticClass:
                                      "device-set-preview-option-virtual-background-btn inside_02",
                                    class: {
                                      selected:
                                        _vm.selectedDevice.video
                                          .virtualBackgroundType ===
                                        "inside_02",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeVirtualBackground(
                                          "inside_02"
                                        )
                                      },
                                    },
                                  }),
                                  _c("button", {
                                    staticClass:
                                      "device-set-preview-option-virtual-background-btn inside_03",
                                    class: {
                                      selected:
                                        _vm.selectedDevice.video
                                          .virtualBackgroundType ===
                                        "inside_03",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeVirtualBackground(
                                          "inside_03"
                                        )
                                      },
                                    },
                                  }),
                                  _c("button", {
                                    staticClass:
                                      "device-set-preview-option-virtual-background-btn inside_04",
                                    class: {
                                      selected:
                                        _vm.selectedDevice.video
                                          .virtualBackgroundType ===
                                        "inside_04",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeVirtualBackground(
                                          "inside_04"
                                        )
                                      },
                                    },
                                  }),
                                  _c("button", {
                                    staticClass:
                                      "device-set-preview-option-virtual-background-btn outside_01",
                                    class: {
                                      selected:
                                        _vm.selectedDevice.video
                                          .virtualBackgroundType ===
                                        "outside_01",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeVirtualBackground(
                                          "outside_01"
                                        )
                                      },
                                    },
                                  }),
                                  _c("button", {
                                    staticClass:
                                      "device-set-preview-option-virtual-background-btn outside_02",
                                    class: {
                                      selected:
                                        _vm.selectedDevice.video
                                          .virtualBackgroundType ===
                                        "outside_02",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeVirtualBackground(
                                          "outside_02"
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "device-set-preview-option-virtual-background-btn-wrapper custom",
                                      class: {
                                        selected:
                                          _vm.selectedDevice.video
                                            .virtualBackgroundType === "custom",
                                      },
                                      style: _vm.virtualBackgroundCustomStyle,
                                    },
                                    [
                                      _c("input", {
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          type: "file",
                                          accept: "image/*",
                                          name: "add-virtual-background",
                                          id: "add-virtual-background",
                                        },
                                        on: {
                                          input:
                                            _vm.onChangeVirtualBackgroundUrl,
                                        },
                                      }),
                                      _c("button", {
                                        staticClass:
                                          "device-set-preview-option-virtual-background-btn apply",
                                        class: {
                                          selected:
                                            _vm.selectedDevice.video
                                              .virtualBackgroundType ===
                                            "custom",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onChangeVirtualBackground(
                                              "custom"
                                            )
                                          },
                                        },
                                      }),
                                      _c("label", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.selectedDevice.video
                                                .virtualBackgroundUrl,
                                            expression:
                                              "!selectedDevice.video.virtualBackgroundUrl",
                                          },
                                        ],
                                        staticClass:
                                          "device-set-preview-option-virtual-background-btn custom",
                                        attrs: {
                                          for: "add-virtual-background",
                                        },
                                      }),
                                      _c(
                                        "label",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.selectedDevice.video
                                                  .virtualBackgroundUrl,
                                              expression:
                                                "selectedDevice.video.virtualBackgroundUrl",
                                            },
                                          ],
                                          staticClass:
                                            "device-set-preview-option-virtual-background-btn change",
                                          attrs: {
                                            for: "add-virtual-background",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.change"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          !_vm.isVirtualBgAvailable
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-disabled-wrapper",
                                },
                                [
                                  _c("p", {
                                    staticClass:
                                      "device-set-preview-option-disabled-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.virtualBgAvailableText
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedTab === "audio",
                          expression: "selectedTab === 'audio'",
                        },
                      ],
                      staticClass: "device-set-preview-option-contents",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "device-set-preview-option-section" },
                        [
                          _c(
                            "div",
                            { staticClass: "device-set-preview-option-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-title-wrapper",
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "device-set-preview-option-title",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isIOS || _vm.isSafari
                                            ? _vm.$t(
                                                "deviceSetting.preview.micNspeaker.title"
                                              )
                                            : _vm.$t("common.device.mic")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "device-set-preview-option-body" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-select-wrapper",
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.selectedDevice.audio.deviceId,
                                          expression:
                                            "selectedDevice.audio.deviceId",
                                        },
                                      ],
                                      staticClass: "form-select",
                                      on: {
                                        input: function ($event) {
                                          return _vm.onChangeDevice(
                                            "audio",
                                            $event.target.value
                                          )
                                        },
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.selectedDevice.audio,
                                            "deviceId",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.devices.audioinput,
                                      function (device) {
                                        return _c(
                                          "option",
                                          {
                                            key: device.deviceId,
                                            domProps: {
                                              value: device.deviceId,
                                            },
                                          },
                                          [_vm._v(_vm._s(device.label))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-mic-volume-wrapper",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "device-set-preview-option-mic-volume overflow-hidden",
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "device-set-preview-option-mic-volume-fill",
                                        style: `transform: scaleX(${_vm.selectedDevice.audio.volume})`,
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-deep-hearing-container",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "toggle-btn-container" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.selectedDevice.audio
                                                .useNoiseCancel,
                                            expression:
                                              "selectedDevice.audio.useNoiseCancel",
                                          },
                                        ],
                                        staticClass: "toggle-btn deepHearing",
                                        attrs: {
                                          type: "checkbox",
                                          name: "deep-hearing",
                                          id: "deep-hearing",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.selectedDevice.audio
                                              .useNoiseCancel
                                          )
                                            ? _vm._i(
                                                _vm.selectedDevice.audio
                                                  .useNoiseCancel,
                                                null
                                              ) > -1
                                            : _vm.selectedDevice.audio
                                                .useNoiseCancel,
                                        },
                                        on: {
                                          input: _vm.toggleNoiseCancel,
                                          change: function ($event) {
                                            var $$a =
                                                _vm.selectedDevice.audio
                                                  .useNoiseCancel,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.selectedDevice.audio,
                                                    "useNoiseCancel",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.selectedDevice.audio,
                                                    "useNoiseCancel",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.selectedDevice.audio,
                                                "useNoiseCancel",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "toggle-label",
                                          attrs: { for: "deep-hearing" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "toggle-info" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "toggle-label-text deep-hearing",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "deviceSetting.preview.deepHearing.title"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "description-container",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "description-btn",
                                                    },
                                                    [_vm._v("?")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "description-modal",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "description-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "deviceSetting.preview.deepHearing.text"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("div", {
                                            staticClass: "toggle-status",
                                            class: {
                                              disabled:
                                                !_vm.isNoiseCancelAvailable,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm.devices.audiooutput?.length
                        ? _c(
                            "div",
                            {
                              staticClass: "device-set-preview-option-section",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-header",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "device-set-preview-option-title-wrapper",
                                    },
                                    [
                                      _c(
                                        "h3",
                                        {
                                          staticClass:
                                            "device-set-preview-option-title",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("common.device.speaker")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "device-set-preview-option-body",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "device-set-preview-option-select-wrapper",
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.selectedDevice.audiooutput
                                                  .deviceId,
                                              expression:
                                                "selectedDevice.audiooutput.deviceId",
                                            },
                                          ],
                                          staticClass: "form-select",
                                          on: {
                                            input: function ($event) {
                                              return _vm.onChangeDevice(
                                                "audiooutput",
                                                $event.target.value
                                              )
                                            },
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.selectedDevice.audiooutput,
                                                "deviceId",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        _vm._l(
                                          _vm.devices.audiooutput,
                                          function (device) {
                                            return _c(
                                              "option",
                                              {
                                                key: device.deviceId,
                                                domProps: {
                                                  value: device.deviceId,
                                                },
                                              },
                                              [_vm._v(_vm._s(device.label))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.isDevicetest && !_vm.isSafari
                        ? _c(
                            "div",
                            {
                              staticClass: "device-set-preview-option-section",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "device-set-preview-option-mic-speaker-test-btn-wrapper",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "device-set-preview-option-mic-speaker-test-btn",
                                      on: { click: _vm.onToggleAudioTest },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "deviceSetting.preview.micNspeaker.test"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "device-set-preview-help-container" }, [
            _c("p", { staticClass: "device-set-preview-help-text" }, [
              _vm._v(_vm._s(_vm.$t("deviceSetting.preview.device.problem"))),
            ]),
            _c(
              "a",
              {
                staticClass: "device-set-preview-help-link",
                attrs: {
                  target: "_blank",
                  href: "https://bizguide.gooroomee.com/efc908fc-baa8-4a02-bbb1-48645a5e5d2b",
                },
              },
              [_vm._v(_vm._s(_vm.$t("deviceSetting.preview.settingGuide")))]
            ),
          ]),
          _c("div", { staticClass: "device-set-preview-footer" }, [
            _vm.isDevicetest
              ? _c(
                  "div",
                  {
                    staticClass:
                      "device-set-preview-join-room-btn-wrapper mobile",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "default-btn join-request-btn",
                        on: { click: _vm.join },
                      },
                      [_vm._v(_vm._s(_vm.joinText))]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "default-btn home",
                        attrs: { href: "/service/room" },
                      },
                      [_vm._v(_vm._s(_vm.$t("deviceSetting.preview.toHome")))]
                    ),
                    _vm._m(2),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "device-set-preview-join-room-btn-wrapper rounded relative overflow-hidden",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "default-btn",
                        on: { click: _vm.applyChangedDevice },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.save")))]
                    ),
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      [
                        _vm.selectedDevice.video.state === "loading"
                          ? _c("GrmLoadingCircle", {
                              staticClass:
                                "bg-black bg-opacity-50 absolute inset-0",
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]),
        ]),
      ]),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isShowAudioTest
            ? _c("DeviceSettingAudioTest", {
                ref: "audioTest",
                staticClass: "device-setting-audio-test-component",
                attrs: {
                  audio: _vm.selectedDevice.audio,
                  audiooutput: _vm.selectedDevice.audiooutput,
                },
                on: { onToggleAudioTest: _vm.onToggleAudioTest },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "device-set-preview-option-beta" }, [
      _c("img", { attrs: { src: require("@/assets/images/beta_blue.svg") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_07.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "loading-obj-group" }, [
      _c("li", { staticClass: "loading-obj obj-1" }),
      _c("li", { staticClass: "loading-obj obj-2" }),
      _c("li", { staticClass: "loading-obj obj-3" }),
      _c("li", { staticClass: "loading-obj obj-4" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }